<template>
    <div style="display:flex;">
        <div class="draw-switch">
            <div :class="drawing===1 ? 'active' : ''"
                 class="item first"
                 @click="switchDrawingMode(1)">
                <span>点选</span>
            </div>
            <div :class="drawing===2 ? 'active' : ''"
                 class="item last"
                 @click="switchDrawingMode(2)">
                <span>框选</span>
            </div>
            <el-tooltip effect="dark" content="双击完成绘制" placement="bottom">
            <div :class="drawing===3 ? 'active' : ''"
                 class="item last"
                 @click="switchDrawingMode(3)">
                <span>多边形</span>
            </div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: 'drawingSwitch',
    data () {
        return {
            drawing: 1
        };
    },
    props: {
        mapController: {
            type: Object,
            default: () => {
                return {};
            }
        },
        parms: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    methods: {
        switchDrawingMode (drawing) {
            if (drawing !== this.drawing) {
                this.drawing = drawing;
                this.mapController.switchDrawingMode(drawing);
            }
        }
    }
};
</script>

<style scoped lang="less">
.draw-switch {
    background-color: white;
    border-radius: 4px;
    display: flex;

    .item {
        width: 50px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-left: 1px solid #00bcbe;
        cursor: pointer;
        font-size: 12px;

        &.active {
            color: white;
            background-color: #00bcbe;
        }
    }

    .first {
        border-left: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .last {
        border-left:1px solid #f3f4f4;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
}
</style>
